import { render, staticRenderFns } from "./AruStatusIcon.vue?vue&type=template&id=529c3d53&"
import script from "./AruStatusIcon.vue?vue&type=script&lang=js&"
export * from "./AruStatusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports